import React from 'react'
import {connect} from 'react-redux'
import HistoryCharts from "../components/HistoryCharts"
import {collapseSections, storeHistorySelection} from "../state/actions/app"

const mapDispatchAsProps = dispatch =>({
    collapse: (current)=>dispatch(collapseSections("history", current)),
    storeSelection: (selection)=> dispatch(storeHistorySelection(selection))
})

const mapStateAsProps = state =>({
    collapsed: state.summariesState.history,
    isExperimental: state.projectInfo.isExperimental,
    historyData: state.historyData,
    report: state.projectInfo.report
  })



const SummariesSelector = (props) =>{
    const history = props.history || []
    const options = history.reduce((result, current,i)=>{
        const index = i+1
        if ( index >= history.length-1 ){
            return result
        }
        if ( index > 0 && ( index % 5 === 0) ){
            result.push(index)
        }
        return result
    },[])
    options.push("All")
    
    
    const defaultChecked = props.selection || options[0]

    return (
    
    history.length>5?<select className="btn btn-light float-right" id="history-summary-selector" defaultValue={defaultChecked} onChange={(e)=>{props.setSelection(e.target.value)}}>
        { 
            options.map((current,i)=>{
                if (i===options.length-1){
                    return <option key={"opt"+current} value={history.length}> All reports</option>
                }
                return <option key={"opt"+current} value={current}> Last {current} reports</option>
            })
        }
    </select>:"")
}



const HistorySummary = (props)=>{
    const history = props.historyData && props.historyData.history? props.historyData.history : []
    return props.report.thresholds?
        <div className="row mb-5">
            <div className="container-fluid" id="history-summary">
                <h3 className="mt-1 report-header d-inline">
                    <i className="fas fa-history mr-2" style={{color:'gray'}}></i>PROJECT HISTORY 
                </h3> 
                <i tabIndex={0} className={(props.collapsed?"fa-plus-square":"fa-minus-square")+" far fa-lg section-minimizer ml-2" } onClick={()=>props.collapse(props.collapsed)} onKeyUp={(e)=>{if(e.key.toLocaleLowerCase()=="enter") props.collapse(props.collapsed)}}></i>
                { props.collapsed? "" : <SummariesSelector history = {history} selection = {props.historyData.selectedOption} setSelection = {props.storeSelection}/> }
                
                { props.collapsed ? "" : <HistoryCharts selection = {props.historyData.selectedOption} projectsController = {props.projectsController} /> }
            </div>  
        </div>

        :

        ""
}

export default connect(mapStateAsProps, mapDispatchAsProps)(HistorySummary)
